export class GlobalVariableConstants {

  public static saveNewFileKey: string = "saveNewFile";
  public static addVersionKey: string = "addVersion";

  public static duplicateFileSaveOptions: any[] = [
    { key: GlobalVariableConstants.saveNewFileKey, value: 'Save as new file' },
    { key: GlobalVariableConstants.addVersionKey, value: 'Add as new version' }
  ];


}